import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IMerchantUpdateressUpdateRequest {
    id: number;
    merchantId?: number;
    description?: string;
    merchantCurrentBalanceTypeId?: number;
    merchantCurrentBalanceType?: number;
    amount?: number;
}

async function merchantCurrentBalanceMovementUpdate(
    data: IMerchantUpdateressUpdateRequest
): Promise<any> {
    try {
        return (await axiosInstance.put("/MerchantCurrentBalanceMovement/Update", data))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useMerchantCurrentBalanceMovementUpdate() {
    return useMutation<any, Error, IMerchantUpdateressUpdateRequest>(
        (variables) => merchantCurrentBalanceMovementUpdate(variables)
    );
}
